import { render, staticRenderFns } from "./KnowledgeFeedList.vue?vue&type=template&id=285be5e0&scoped=true&"
import script from "./KnowledgeFeedList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFeedList.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeFeedList.vue?vue&type=style&index=0&id=285be5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285be5e0",
  null
  
)

export default component.exports